import axios from 'axios';
export const efoApi = (method, path, data, options = {}) => axios({
  method, url: process.env.REACT_APP_API_HOST + '/api/v2/simplified-employment-day' + path, data,
  headers: {'Authorization': 'Bearer ' + localStorage.getItem('userToken'), 'App-Network': localStorage.getItem('networkId')}, ...options,
});
export const efoError = async (error) => {
  let data = error.response?.data;
  if (data instanceof Blob) {try {data = JSON.parse(await data.text());} catch (_) {data = null;}}
  return data?.message || data?.detail || error.message;
};
export const saveEfoDownload = (response, fallback) => {
  const name = response.headers['content-disposition']?.match(/filename="?([^";]+)"?/)?.[1] || fallback;
  const url = URL.createObjectURL(response.data);
  const link = document.createElement('a'); link.href = url; link.download = name;
  document.body.appendChild(link); link.click(); link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};
